
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  onMounted,
  ref,
} from 'vue'

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      visible: false,
      titlename: '详情',
      formdata: ref<any>({}),
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    /**
     * @description: 格式化JSON字符串
     * @param {string} jsonString - 需要格式化的JSON字符串
     * @return {string} 格式化后的JSON字符串
     */
    const formatJsonString = (jsonString: string): string => {
      try {
        const parsed = JSON.parse(jsonString)
        return JSON.stringify(parsed, null, 2)
      } catch (error) {
        return jsonString
      }
    }

    /**
     * @description: 关闭dialog
     * @param {*} void
     * @return {*}
     */
    const onCancel = (): void => {
      data.visible = false
      emit('update:modelValue', false)
    }
    onMounted(() => {
      data.formdata = props.row
    })
    return {
      ...toRefs(data),

      onCancel,
      formatJsonString,
    }
  },
})
